import { render } from "./PublishTransactionsModal.vue?vue&type=template&id=9af3346e"
import script from "./PublishTransactionsModal.vue?vue&type=script&lang=js"
export * from "./PublishTransactionsModal.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__